export const I18n = {
	'en': {
		status: 'Status',
		name: 'Name',
		country: 'Country',
		city: 'City',
		address: 'Address',
		activePackages: 'Active packages',
		operatorCompanies: 'Operator companies',
		statusPending: 'Pending',
		statusBlocked: 'Blocked',
		statusActive: 'Active',
		noStatus: 'None',
		addMember: 'Add member',
		delMember: 'Delete member',
		cancel: 'Cancel',
		save: 'Save',
		all: 'All',
		tt_attributes: 'Traders point attributes',
		latitude: 'Latitude',
		longitude: 'Longitude',
		openingTime: 'Opening time',
		closingTime: 'Closing time',
		schedule: 'Schedule',
		dayOfWeek: {
			monday: 'Monday',
			tuesday: 'Tuesday',
			wednesday: 'Wednesday',
			thursday: 'Thursday',
			friday: 'Friday',
			saturday: 'Saturday',
			sunday: 'Sunday',
		}
	},
	'ru': {
		status: 'Статус',
		name: 'Название',
		country: 'Страна',
		city: 'Город',
		address: 'Адрес',
		activePackages: 'Активные пакеты',
		operatorCompanies: 'Компании операторов',
		statusPending: 'В ожидании',
		statusBlocked: 'Заблокирован',
		statusActive: 'Активный',
		noStatus: 'Не назначен',
		addMember: 'Добавить сотрудника',
		delMember: 'Удалить сотрудника',
		cancel: 'Отмена',
		save: 'Сохранить',
		all: 'Все',
		tt_attributes: 'Атрибуты торговой точки',
		latitude: 'Широта',
		longitude: 'Долгота',
		openingTime: 'Время открытия',
		closingTime: 'Время закрытия',
		schedule: 'Расписание',
		dayOfWeek: {
			monday: 'Понедельник',
			tuesday: 'Вторник',
			wednesday: 'Среда',
			thursday: 'Четверг',
			friday: 'Пятница',
			saturday: 'Суббота',
			sunday: 'Воскресенье',
		}
	},
	'sk': {
		status: 'Postavenie',
		name: 'Názov',
		country: 'Krajina',
		city: 'Veľkomesto',
		address: 'Adresu',
		activePackages: 'Aktívne balíček',
		operatorCompanies: 'Operátorské spoločnosti',
		statusPending: 'Nevykonaného',
		statusBlocked: 'Upchatý',
		statusActive: 'Aktívny',
		noStatus: 'Nikto',
		addMember: 'Pridať člena',
		delMember: 'Odstrániť člena',
		cancel: 'Zrušiť',
		save: 'Uložiť',
		all: 'Všetko',
		tt_attributes: 'Obchodníci poukazujú atribúty',
		latitude: 'Latitude',
		longitude: 'Longitude',
		openingTime: 'Opening time',
		closingTime: 'Closing time',
		schedule: 'Schedule',
		dayOfWeek: {
			monday: 'Monday',
			tuesday: 'Tuesday',
			wednesday: 'Wednesday',
			thursday: 'Thursday',
			friday: 'Friday',
			saturday: 'Saturday',
			sunday: 'Sunday',
		}
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/store/index.js